import React from "react";
import classNames from "classnames";
import "./container.scss";
export const Container = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    mt = 12,
    type,
    className,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("section", {
    className: classNames(type ? "container-".concat(type) : "container", "flex", className, "mt-".concat(mt)),
    ref: ref
  }, children);
});